/**
 * 前端入口。
 *
 * 主题必须在首屏渲染之前应用：晚一帧就会看到浅色闪一下再变深色。
 * 所以 initTheme() 在 render 之前同步调用，而不是放进 effect。
 *
 * 不要在这里 import 业务模块。入口越薄，"为什么这里有这段逻辑"这类问题就越少。
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './styles/index.css';
import { initTheme } from './theme';

const container = document.getElementById('root');
if (!container) throw new Error('找不到 #root 挂载点');

initTheme();

createRoot(container).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
